module.exports = __webpack_public_path__ + "static/media/user_profile.df35d5a5.svg";